import { Wording } from '@/types';

export const ASTROLOGY_WORDING_FI: Wording = {
  components_header_media_content: 'Äänet',
  components_header_media_1: 'Meditaatiot',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Oppaat',
  components_header_text2: 'Blogi',
  components_header_members: 'jäsenet',
  hero_text: 'Tutustu tähtiin sisällä',
  hero_button_text: 'Aloita tästä',
  components_ressources_section_title: 'RESURSSIT',
  components_ressources_subheader_text: 'Kaikki työkalut, joita tarvitset kosmiseen näkemykseen ja itsensä löytämiseen',
  components_ressources_span_text: 'Laajenna sisäistä universumiasi podcastien ja artikkelien kuratoidulla sekoituksella. Etsitpä sitten kosmista oivallusta, selkeyttä tai henkistä linjausta, resurssimme auttavat sinua saamaan yhteyden astrologiaan käytännöllisillä ja merkityksellisillä tavoilla.',
  components_ressources_card_1_title: 'Syväsukellukset',
  components_ressources_card_1_text: 'Sukella runsaaseen kokoelmaan syvällisiä podcasteja, jotka kattavat astrologian, tarot, kosmiset arkkityypit ja henkisen kasvun – suunniteltu laajentamaan tietoisuuttasi ja syventämään harjoitteluasi.',
  components_ressources_card_2_title: 'Star Insights',
  components_ressources_card_2_text: 'Astrologisia vinkkejä ja blogitekstejä itsetietoisuuteen ja sielulliseen kasvuun.',
  components_ressources_link: 'Tutustu tarkemmin',
  components_notes_and_google_title_1: 'Astrologinen opastus',
  components_notes_and_google_title_2: 'Kosminen rutiini',
  components_notes_and_google_title_3: 'Heijastuksia',
  components_review_google_text: 'Arvostelut',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Meidän podcast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Lisää jaksoja',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: 'Artikkelit ja oivallukset',
  text2_section_button_more: 'Lataa lisää',
  components_text1_section_title: 'OPPAAT',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Näytä kaikki oppaat',
  components_footer_text: 'Herätä sisäinen kosmos: polkusi, tähdesi.',
  components_footer_info: 'Tiedot',
  components_footer_registration_number: 'Rekisterinumero',
  components_footer_legal: 'Laillinen',
  components_footer_terms: 'Ehdot',
  components_footer_privacy: 'Tietosuojakäytäntö',
  button_load_more: 'Lataa lisää',
  page_media_1_content_hero_text: 'Podcast-jaksot',
  page_media_content_menu_foundations: 'Säätiöt',
  page_media_content_menu_spirituality: 'Hengellisyys',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psykologia',
  page_media_content_menu_trends: 'Trendit',
  page_media_2_content_hero_text: 'Media 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Meidän blogi',
  page_text2_section_title: 'Blogi',
  page_text2_subheader_text: 'Artikkelit ja oivallukset',
  enter_email_title: 'Anna sähköpostiosoitteesi jatkaaksesi',
  enter_email_placeholder_email: 'Sähköposti',
  enter_email_button_enter: 'Enter',
  components_login_success_text: 'Kirjautuminen onnistui!',
  components_card_link_media_content: 'Kuuntele nyt',
  components_card_link_text1_content: 'Näytä opas',
  components_card_link_text2_content: 'Katso artikkeli',
  france: 'Ranska',
  cyprus: 'Kypros',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditaatio',
  page_media_content_menu_all: 'Kaikki',
};